"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOT_AUTHED = exports.AUTHED = void 0;
var AUTHED = 'AUTHED';
exports.AUTHED = AUTHED;
var NOT_AUTHED = 'NOT_AUTHED';
exports.NOT_AUTHED = NOT_AUTHED;